import type { HeaderNotificationsProps } from './header.types'

import { Badge } from '../badge'
import Button from '../button'
import { useStyleConfig, vui } from '../core'
import { cs } from '../utils'
import { useHeaderContext } from './context'

/** Icon link to Veracity notifications engine with an optional number of new notifications. */
export const HeaderNotifications = vui<'a', HeaderNotificationsProps>((props, ref) => {
  const { children, className, count = 0, url, ...rest } = props
  const { links } = useHeaderContext() ?? {}
  const styles = useStyleConfig('Header', useHeaderContext()).notifications

  return (
    <Button
      as="a"
      className={cs('vui-headerNotifications', className)}
      href={url ?? links.notifications}
      minW={0}
      position="relative"
      px="9px"
      ref={ref}
      size="lg"
      title="Notifications"
      variant="tertiary"
      {...styles.container}
      {...rest}
      w="40px"
      overflow="visible"
    >
      {children ?? (
        <>
          <Button.Icon name="uiBell" />
          {count > 0 && (
            <Badge
              aria-label={`${count} new notifications`}
              size="xs"
              variant="solid"
              color="red"
              position="absolute"
              top={-3}
              right={-3}
              maxW="20px"
            >
              {count < 10 ? count : '9+'}
            </Badge>
          )}
        </>
      )}
    </Button>
  )
})

HeaderNotifications.displayName = 'HeaderNotifications'

export default HeaderNotifications
